<template>
  <div>
    <b-row v-if="label" align-h="center">
      <label class="d-block">{{ label }}</label>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="From" :label-for="fromId" label-align="center">
          <b-form-timepicker
            :id="fromId"
            v-model="localValue.from"
            v-bind="$attrs"
          ></b-form-timepicker>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="To" :label-for="toId" label-align="center">
          <b-form-timepicker
            :id="toId"
            v-model="localValue.to"
            v-bind="$attrs"
          ></b-form-timepicker>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      from: {
        type: String,
        default: ""
      },
      to: {
        type: String,
        default: ""
      },
      default() {
        return {
          from: "",
          to: ""
        };
      }
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    fieldName: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    fromId() {
      return `${this.fieldName}-from`;
    },
    toId() {
      return `${this.fieldName}-to`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
